import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class LoadingService {
    private loadingOverlay!: HTMLElement;
    private renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.createLoadingOverlay();
    }

    private createLoadingOverlay(): void {
        this.loadingOverlay = this.renderer.createElement("div");
        this.renderer.setAttribute(this.loadingOverlay, "id", "loading-overlay");
        this.renderer.setStyle(this.loadingOverlay, "position", "fixed");
        this.renderer.setStyle(this.loadingOverlay, "top", "0");
        this.renderer.setStyle(this.loadingOverlay, "left", "0");
        this.renderer.setStyle(this.loadingOverlay, "width", "100vw");
        this.renderer.setStyle(this.loadingOverlay, "height", "100vh");
        this.renderer.setStyle(this.loadingOverlay, "display", "none");
        this.renderer.setStyle(this.loadingOverlay, "align-items", "center");
        this.renderer.setStyle(this.loadingOverlay, "justify-content", "center");
        this.renderer.setStyle(this.loadingOverlay, "background", "rgba(230, 230, 230, 0.1)");
        this.renderer.setStyle(this.loadingOverlay, "backdrop-filter", "blur(15px)");
        this.renderer.setStyle(this.loadingOverlay, "z-index", "9999");

        const img = this.renderer.createElement("img");
        this.renderer.setAttribute(img, "src", `assets/images/${environment.logo}`);
        this.renderer.setAttribute(img, "alt", "Loading");
        this.renderer.setAttribute(img, "class", "loading-overlay-logo");
        this.renderer.setStyle(img, "width", "200px");
        this.renderer.setStyle(img, "height", "200px");
        this.renderer.setStyle(img, "animation", "breathe 2.2s ease-in-out infinite");

        this.renderer.appendChild(this.loadingOverlay, img);
        this.renderer.appendChild(document.body, this.loadingOverlay);
    }

    show(): void {
        this.renderer.setStyle(this.loadingOverlay, "display", "flex");
        this.renderer.addClass(document.body, "loading-active");
    }

    hide(): void {
        this.renderer.setStyle(this.loadingOverlay, "display", "none");
        this.renderer.removeClass(document.body, "loading-active");
        
    }
}
